<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true"
  [config]="{ignoreBackdropClick: true, keyboard: false}" (onShown)="onShown()">
  <div class="modal-dialog modal-lg">
    <mat-progress-bar *ngIf="isBusy" mode="indeterminate"></mat-progress-bar>
    <div class="card modal-content" *ngIf="form">
      <form (ngSubmit)="save()" [formGroup]="form">
        <div class="header">
          <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h2>Entrega de Exame</h2>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" *ngIf="errors.length > 0">
            <h3>Oops! Algo deu errado:</h3>
            <ul>
              <li *ngFor="let error of errors"></li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-2">
              <mat-form-field>
                <mat-label>Atendimento</mat-label>
                <input matInput disabled [value]="atendimento?.codigoDocMovto" type="text" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Paciente</mat-label>
                <input matInput disabled [value]="paciente?.pessoa?.nomeFantasia" type="text" />
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Procedimento</mat-label>
                <input matInput disabled [value]="procedimento?.nome" type="text" />
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-slide-toggle matSuffix color="primary" formControlName="entregue">Entregue</mat-slide-toggle>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Data de Entrega</mat-label>
                <input *ngIf="form.value.entregue" matInput formControlName="dataEntrega" type="date" />
                <input *ngIf="!form.value.entregue" matInput disabled [value]="form.value.dataEntrega" type="date" />
                <mat-error>Informe um Data de Entrega válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-8">
              <mat-form-field>
                <mat-label>Entregue Para</mat-label>
                <input *ngIf="form.value.entregue" matInput formControlName="entreguePara" type="text" />
                <input *ngIf="!form.value.entregue" matInput disabled [value]="form.value.entreguePara" type="text" />
                <mat-error>Informe um Entregue Para válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Observacoes</mat-label>
                <textarea matInput formControlName="observacoes" rows="4"></textarea>
                <mat-error>Informe um Observacoes válido.</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
      <div class="footer">
        <mat-slide-toggle [(ngModel)]="multiCreate" color="primary" *ngIf="newItem" style="margin-right: 10px;">
          Continuar Incluindo
        </mat-slide-toggle>
        <button mat-flat-button [disabled]="!form.valid || isBusy" type="submit" (click)="save()" color="primary"
          class="button-row">
          <span> Salvar</span>
        </button>
        <button mat-stroked-button type="button" [routerLink]="" (click)="close()" class="button-row">
          <span> Cancelar</span>
        </button>
      </div>
    </div>
  </div>
</div>